import React from "react";
import Wrapper from "../components";

type Props = {};

export default function Survey({}: Props) {
  return <Wrapper />;
}
